import { createContext } from "react";

type ColorModeContextType = {
  mode: "light" | "dark";
  setMode: () => void;
};

export const ColorModeContext = createContext<ColorModeContextType>(
  {} as ColorModeContextType
);
